export default function VisionSection() {
  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
            私たちのビジョン
          </h2>
          <div className="max-w-4xl mx-auto">
            <p className="text-2xl lg:text-3xl font-bold text-[#2A6041] mb-8">
              「農業の未来を、テクノロジーで変える」
            </p>
            <div className="text-lg text-gray-700 leading-relaxed space-y-6">
              <p>
                日本の農業は高齢化と重労働という課題に直面していますが、これを「変革のチャンス」と捉えています。スマート農業は単に「楽になる農業」ではなく、効率化で生まれた時間を作付面積拡大や新しい挑戦に使う。それこそが農業の持続可能性と収益性を高める鍵です。
              </p>
              <p>
                若い世代が「やってみたい」、ベテラン農家が「まだまだできる」と実感できる農業を実現します。スマート農業で未来を変える。それが私たちの使命です。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}